/** 정산표 → DSD 변환의 보고서 종류 선택지. 값은 변환 API 파라미터 그대로다. */

export type AccountingSheetPeriod =
  | "quarterly_1"
  | "semi_annual"
  | "quarterly_3"
  | "annual";
export type ConsolidationType = "consolidated" | "separate";

export const REPORT_FORMAT_ITEMS = [
  { value: "audit" as const, label: "정기" },
  { value: "pre_audit" as const, label: "감사전" },
];

export const PERIOD_ITEMS = [
  { value: "quarterly_1" as const, label: "1분기" },
  { value: "semi_annual" as const, label: "반기" },
  { value: "quarterly_3" as const, label: "3분기" },
  { value: "annual" as const, label: "사업" },
];

export const CONSOLIDATION_ITEMS = [
  { value: "consolidated" as const, label: "연결" },
  { value: "separate" as const, label: "별도" },
];

// 표지 날짜 자동 입력에 쓰이는 회계연도. 디폴트는 KST 기준 올해.
export const CURRENT_YEAR_KST = Number(
  new Intl.DateTimeFormat("en-US", {
    timeZone: "Asia/Seoul",
    year: "numeric",
  }).format(new Date()),
);

export const YEAR_ITEMS = [
  CURRENT_YEAR_KST,
  CURRENT_YEAR_KST - 1,
  CURRENT_YEAR_KST - 2,
].map((year) => ({ value: String(year), label: `${year}년` }));
